import { useState, useEffect, useRef, useMemo } from 'react';

// Фильтр по столбцу таблицы с множественным выбором — щёлкнули по нескольким проектам/
// менеджерам/статьям сразу, строка проходит, если её значение совпадает хотя бы с одним
// отмеченным (внутри столбца — ИЛИ, между столбцами таблицы — И, см. DataTable).
export default function MultiSelectFilter({ options, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const boxRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  useEffect(() => { if (!open) setQuery(''); }, [open]);

  const filteredOptions = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return options;
    return options.filter(o => o.toLowerCase().includes(q));
  }, [options, query]);

  const toggle = (opt) => {
    onChange(selected.includes(opt) ? selected.filter(v => v !== opt) : [...selected, opt]);
  };

  const label = selected.length === 0 ? 'Все'
    : selected.length === 1 ? selected[0]
    : `Выбрано: ${selected.length}`;

  return (
    <div className="ms-filter" ref={boxRef}>
      <button
        type="button"
        className={`ms-filter-btn${selected.length ? ' ms-filter-btn-active' : ''}`}
        onClick={e => { e.stopPropagation(); setOpen(o => !o); }}
        title={label}
      >
        {label} ▾
      </button>
      {open && (
        <div className="ms-filter-list" onClick={e => e.stopPropagation()}>
          <input
            className="ms-filter-search"
            placeholder="Поиск..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            autoFocus
          />
          <div className="ms-filter-actions">
            <button type="button" onClick={() => onChange(filteredOptions)}>Выбрать все</button>
            <button type="button" onClick={() => onChange([])}>Сбросить</button>
          </div>
          <div className="ms-filter-options">
            {filteredOptions.length === 0 && <div className="search-select-empty">Ничего не найдено</div>}
            {filteredOptions.map(opt => (
              <label key={opt} className="ms-filter-item">
                <input type="checkbox" checked={selected.includes(opt)} onChange={() => toggle(opt)} />
                <span>{opt || '—'}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
